import React, { lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import {
  validServiceSlugs,
  validIndustrySlugs,
  locationCitySlugs,
  locationServiceCombinedSlugs,
} from '@/data/urlMappings';

const ServicePage = lazy(() => import('@/pages/ServicePage'));
const IndustryDetailPage = lazy(() => import('@/pages/IndustryDetailPage'));
const LocationCityPage = lazy(() => import('@/pages/LocationCityPage'));
const LocationServicePage = lazy(() => import('@/pages/LocationServicePage'));
const ContactUsPage = lazy(() => import('@/pages/ContactUsPage'));
const PrivacyPolicyPage = lazy(() => import('@/pages/PrivacyPolicyPage'));
const TermsConditionsPage = lazy(() => import('@/pages/TermsConditionsPage'));

const Loader = () => (
  <div className="min-h-screen bg-[#050505] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-[#E63946] border-t-transparent rounded-full animate-spin" />
  </div>
);

const staticPages = {
  'contact-us': ContactUsPage,
  'privacy-policy': PrivacyPolicyPage,
  'terms-and-conditions': TermsConditionsPage,
};

const PageResolver = () => {
  const { slug } = useParams();

  let content;

  if (staticPages[slug]) {
    const Page = staticPages[slug];
    content = <Page />;
  } else if (validServiceSlugs.has(slug)) {
    content = <ServicePage />;
  } else if (validIndustrySlugs.has(slug)) {
    content = <IndustryDetailPage />;
  } else if (locationCitySlugs[slug]) {
    content = <LocationCityPage cityKey={locationCitySlugs[slug]} />;
  } else if (locationServiceCombinedSlugs[slug]) {
    const { city, service } = locationServiceCombinedSlugs[slug];
    content = <LocationServicePage key={slug} cityKey={city} serviceKey={service} />;
  } else {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl text-white mb-4">Page Not Found</h1>
          <a href="/" className="text-[#E63946] hover:underline">Return Home</a>
        </div>
      </div>
    );
  }

  return <Suspense fallback={<Loader />}>{content}</Suspense>;
};

export default PageResolver;
